'use client'

import React, { useEffect, useRef, useState } from 'react'
import curtainCloseBtn from '@/assets/img/catalog/catalog-sort-curtainClose.svg'
import Image from 'next/image'
import { Filter } from '@/features/catalog/ui/Filter'
import { FilterWrapper } from '@/screens/catalog/ui/components/FilterWrapper'
import { Checkbox } from '@/features/catalog/ui/Checkbox'
const FilterOptionWrapper = ({ children }) => <>{children}</>

interface Props {
    curtainOpen: boolean
    setCurtainOpen: (state: boolean) => void
    filters: any
    catalogParams: any
}

const CatalogSortCurtain: React.FC<Props> = ({ curtainOpen, setCurtainOpen, filters, catalogParams }) => {
    const curtainRef = useRef(null)
    const toggleCurtain = () => {
        setCurtainOpen(!curtainOpen)
        if (!curtainOpen) {
            document.body.classList.add('no-scroll')
        } else {
            document.body.classList.remove('no-scroll')
        }
    }

    React.useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (curtainRef.current && !event.composedPath().includes(curtainRef.current) && curtainOpen) {
                setCurtainOpen(false)
                document.body.classList.remove('no-scroll')
            }
        }

        document.body.addEventListener('click', handleClickOutside)
        return () => document.body.removeEventListener('click', handleClickOutside)
    }, [])

    return (
        <>
            <div
                ref={curtainRef}
                className={`catalog__sort-curtain ${curtainOpen ? 'catalog__sort-curtain_open' : ''}`}
    
            >
                {/* <CatalogSort inContainer={true} /> */}
                <Filter
                    components={{
                        FilterWrapper: FilterWrapper,
                        FilterOptionWrapper: FilterOptionWrapper,
                        FilterCheckbox: Checkbox
                    }}
                    catalogParams={catalogParams}
                    filterConfig={(optionTitle: string) => {
                        switch (optionTitle) {
                            case 'Тип продукта':
                                return { type: 'checkbox', updateUrl: 'replace' }
                            default:
                                return { type: 'checkbox' }
                        }
                    }}
                    filterData={filters ? filters : []}
                />
                <div
                    onClick={toggleCurtain}
                    className='catalog__sort-close-curtain'
                >
                    <Image
                        src={curtainCloseBtn}
                        width={20}
                        height={20}
                        alt='close-button'
                    />
                </div>
            </div>
        </>
    )
}

export default CatalogSortCurtain
